<div class="page_layout">
  <div class="page_layout__container">
    <div class="page_layout__container__header">Categories Order</div>
    <div class="page_layout__container__body">
      <div class="page_layout__container__body__drop"></div>
      <div class="page_layout__container__body__CategoryName">Categories</div>
      <div
        class="page_layout__container__body__ListContainer"
        cdkDropList
        (cdkDropListDropped)="drop($event)"
      >
        @for (item of Categories; track item.id) {
        <div
          class="page_layout__container__body__ListContainer__item-box"
          cdkDrag
        >
          {{ item.categoryName }}
        </div>
        }
      </div>
    </div>
  </div>
</div>

<app-admin-success-message> </app-admin-success-message>

